import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const ProtectedDeliveryRoute = ({ children }) => {
  const { loading, isAuthenticated } = useSelector((state) => state.deliveryUser);
  if (loading === false) {
    if (!isAuthenticated) {
      return <Navigate to="/delivery-login" replace />;
    }
    return children;
  }
};

export default ProtectedDeliveryRoute;
